/*
import prestashop from 'prestashop';
import $ from 'jquery';
*/
prestashop.blockcart = prestashop.blockcart || {};


